<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  name: 'AppointmentReport',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          caat: null,
          month: null,
          academicYear: null,
        },
        collections: {
          academicYears: [],
          caats: [],
          months: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de Citas',
        icon: 'fa-solid fa-list font-22 ',
        routes: ['CAAT', 'Reportes', 'Informe de Citas'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'caat',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CAAT',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.caats,
          value: this.model.search.filters.caat,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process(
          this.model.search.filters.dateFrom,
          this.model.search.filters.dateTo
        );
      }
    },
    async getInitialFilters() {
      await this.getCaats();
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentYearAcademicYears()
      ).data;
    },
    async onChangeAcademicYear() {
      if (this.model.search.filters.academicYear == null) {
        this.model.search.collections.months = [];
      } else {
        await this.getMonths(this.model.search.filters.academicYear.id);
      }
    },
    async getCaats() {
      const { data } = await referralAndEquipmentsservice.getCaats();
      this.model.search.collections.caats = data;
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => (this.model.search.collections.schools = res.data));
    },
    async getMonths(yearId) {
      const { data } = await AcademicYearServices.getMonthsInAcademicYear(
        yearId
      );
      this.model.search.collections.months = data;
    },
    async process() {
      await ReportServices.getReport('atappointmentsreport', {
        academicYearId: this.model.search.filters.academicYear?.id,
        caatId: this.model.search.filters.caat?.id,
        month: this.model.search.filters.month?.id,
        monthName: this.model.search.filters.month?.name,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>

<style lang="scss" scoped></style>
